import "../blocks/Footer.css";
import instagramIcon from "../images/platform_logos/Instagram_Glyph_White.svg";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__name-content">
        <p className="footer__text footer__text--name">Carmen Supermarket</p>
      </div>
      <a
        className="footer__social"
        href="https://www.instagram.com/carmensupermarket/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={instagramIcon}
          alt="Instagram de Carmen Supermarket"
          width="28"
          height="28"
        />
      </a>
      <p className="footer__text footer__text--credits">
        Desarrollado por Miguel González | {new Date().getFullYear()}
      </p>
    </footer>
  );
}

export default Footer;
